import { render, staticRenderFns } from "./AddressInput.vue?vue&type=template&id=c5638a10&scoped=true&"
import script from "./AddressInput.vue?vue&type=script&lang=js&"
export * from "./AddressInput.vue?vue&type=script&lang=js&"
import style0 from "./AddressInput.vue?vue&type=style&index=0&id=c5638a10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5638a10",
  null
  
)

export default component.exports